import { useEffect, useState } from 'react'

const getValues = (breakpoint: number) => {
  if (typeof window === 'undefined') {
    return { isDesktop: false, isTablet: false, isMobile: false, isLandscape: false, isTabletPortrait: false }
  }
  const width = window.innerWidth
  const height = window.innerHeight
  const landscape = width > height
  const mobile = width < 768
  const tablet = width >= 768 && width < breakpoint
  const tabletPortrait = tablet && !landscape
  const desktop = width >= breakpoint && !tabletPortrait

  return {
    isDesktop: desktop,
    isTablet: tablet,
    isMobile: mobile,
    isLandscape: landscape,
    isTabletPortrait: tabletPortrait,
  }
}

export const useMediaQuery = (breakpoint: number = 1200) => {
  const [state, setState] = useState(() => getValues(breakpoint))

  useEffect(() => {
    const check = () => setState(getValues(breakpoint))
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])

  return state
}